import CountUp from "react-countup";
import { motion } from "framer-motion";
import { Users, ThumbsUp, Globe, BookOpen } from "lucide-react";

const STATS = [
  { icon: Users, num: 1000, suffix: "+", label: "Students Guided" },
  { icon: ThumbsUp, num: 99, suffix: "%", label: "Student Satisfaction" },
  { icon: Globe, num: 7, suffix: "+", label: "Study Destinations" },
  { icon: BookOpen, num: 10, suffix: "+", label: "Courses Offered" },
];

export default function Stats() {
  return (
    <section data-testid="stats-section" className="py-24 md:py-28 relative overflow-hidden">
      <div className="absolute inset-0 z-0 bg-gradient-to-br from-[#0F3D8C] via-[#0A2D6B] to-[#050B1A]" />
      <div className="absolute inset-0 z-0 opacity-30 bg-[radial-gradient(circle_at_top_right,_rgba(212,175,55,0.4),_transparent_50%)]" />

      <div className="max-w-7xl mx-auto px-6 md:px-8 relative z-10">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {STATS.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              data-testid={`stat-${i}`}
              className="p-8 rounded-3xl bg-white/[0.06] backdrop-blur-xl border border-white/15 text-white text-center shadow-2xl"
            >
              <div className="mx-auto w-14 h-14 rounded-2xl bg-[#D4AF37]/20 flex items-center justify-center text-[#FCD34D] mb-4">
                <s.icon className="w-7 h-7" strokeWidth={1.6} />
              </div>
              <div className="text-5xl font-heading font-light tracking-tight">
                <CountUp end={s.num} duration={2.2} enableScrollSpy scrollSpyOnce />
                <span className="text-gradient-gold">{s.suffix}</span>
              </div>
              <div className="mt-2 text-sm text-white/70 tracking-wide">{s.label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
